import React from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";

export const VideoJS = ( props ) => {

  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const { options, onReady } = props;

  React.useEffect(() => {
    // make sure Video.js player is only initialized once
    if (!playerRef.current) {
      const videoElement = videoRef.current;
      if (!videoElement) return;

      const player = playerRef.current = videojs(videoElement, options, () => {

        player.reloadSourceOnError({
            errorInterval: 5
        });


        player.on('error', async (e) => {

          let targetPlayer = e.target.player;
          const error = targetPlayer.error();
          if (error.code === 4)
          {
            await new Promise(r => setTimeout(r, 5000));

            let options = targetPlayer.options();
            targetPlayer.reset();
            targetPlayer.options(options);
            targetPlayer.src(options.sources);

            onReady && onReady(targetPlayer);
          }
          console.error("VideoJS error event:", e);
          console.log(error);
        });


        console.log("player is ready");
        onReady && onReady(player);
      });
    } else {
      // you can update player here [update player through props]
      // const player = playerRef.current;
      // player.autoplay(options.autoplay);
      // player.src(options.sources);
    }
  }, [options, videoRef, onReady]);

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div data-vjs-player>
      <video ref={videoRef} className="video-js vjs-big-play-centered" />
    </div>
  );
}

export default VideoJS;